module.exports = __webpack_public_path__ + "static/img/video-play-count.8c1678b4.png";